import React from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import * as PropTypes from 'prop-types';

export default function ContenderTable({
  designList,
  textFilter,
  showRank,
  showLocation,
  setSlot,
}) {
  if (designList.length === 0) {
    return (
      <div className="d-flex flex-grow-1 justify-content-center align-items-center">
        <p className="lead">
          No designs found. Try changing your search filters.
        </p>
      </div>
    );
  }

  return (
    <table className="table table-condensed table-striped">
      <thead>
        <tr>
          {showRank && <th>Rank</th>}
          <th>Design</th>
          <th>Engineer</th>
          <th>School</th>
          {showLocation && <th>City</th>}
          {showLocation && <th>State</th>}
        </tr>
      </thead>
      <tbody>
        {designList.map((design) => (
          <DesignRow
            key={design.id}
            setSlot={setSlot}
            showRank={showRank}
            showLocation={showLocation}
            highlightText={textFilter}
            {...design}
          />
        ))}
      </tbody>
    </table>
  );
}

ContenderTable.propTypes = {
  designList: PropTypes.arrayOf(PropTypes.object),
};

const DesignRow = React.memo(function DesignRow({
  setSlot,
  showRank,
  showLocation,
  highlightText,
  rank,
  mine,
  id,
  name,
  studentAlias,
  organizationName,
  city,
  state,
}) {
  let classes = '';
  if (mine > 0) {
    classes += 'mine';
  }
  if (mine === 1) {
    classes += ' best';
  }

  if (highlightText.length) {
    const startPos = name.indexOf(highlightText);
    if (startPos > -1) {
      name = (
        <>
          <span>{name.substring(0, startPos)}</span>
          <span style={{ backgroundColor: '#DDFFDD' }}>{highlightText}</span>
          <span>{name.substring(startPos + highlightText.length)}</span>
        </>
      );
    }
  }

  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="top"
      overlay={
        <Popover id={`design-${id}`}>
          <Popover.Body>
            <Button
              size="sm"
              variant="secondary"
              onClick={() => {
                setSlot(1, id, name);
                document.body.click();
              }}
            >
              Contender 1
            </Button>
            <span> </span>
            <Button
              size="sm"
              variant="secondary"
              onClick={() => {
                setSlot(2, id, name);
                document.body.click();
              }}
            >
              Contender 2
            </Button>
          </Popover.Body>
        </Popover>
      }
    >
      <tr className={classes}>
        {showRank && <td>{rank}</td>}
        <td className="design-name">{name}</td>
        <td>{studentAlias}</td>
        <td>{organizationName}</td>
        {showLocation && <td>{city}</td>}xo
        {showLocation && <td>{state}</td>}
      </tr>
    </OverlayTrigger>
  );
});

DesignRow.defaultProps = {
  rank: null,
  isGameMode: false,
  mine: 0,
};

DesignRow.propTypes = {
  setSlot: PropTypes.func.isRequired,
  rank: PropTypes.number,
  mine: PropTypes.number,
  id: PropTypes.number,
  name: PropTypes.string,
  studentAlias: PropTypes.string,
  organizationName: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
};
